var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KlevuGetBannersByType } from "../../utils/getBannersByType.js";
import { KlevuKMCSettings } from "../kmc.js";
export function getBanners(responseObject, searchType) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        if (!["search", "categoryMerchandising"].includes(responseObject.func.klevuFunctionId)) {
            return [];
        }
        const settings = yield KlevuKMCSettings();
        if (!settings.banner) {
            return [];
        }
        switch (responseObject.func.klevuFunctionId) {
            case "search": {
                if (!searchType) {
                    throw new Error("Search type (landingpage|quicksearch) is required for search query banners");
                }
                const searchTerm = (_a = responseObject.func.params) === null || _a === void 0 ? void 0 : _a.term;
                if (!searchTerm) {
                    throw new Error("Search term is required for search query banners");
                }
                return KlevuGetBannersByType(settings.banner.klevu_banner, searchType, searchTerm);
            }
            case "categoryMerchandising": {
                const category = (_b = responseObject.func.params) === null || _b === void 0 ? void 0 : _b.category;
                if (!category) {
                    return [];
                }
                return KlevuGetBannersByType(settings.banner.klevu_banner, "merchandising", category);
            }
        }
        throw new Error("Couldn't find banners for this query. Unknown query type.");
    });
}
